
  const { hot } = require("react-hot-loader/root")
  import Component from "/opt/build/repo/src/theme/organisms/IFrame/index.ts"

  export default hot(Component)
  